// src/features/works/components/DocumentForm.jsx
import React from 'react';
import DocumentUploadForm from '../../../components/DocumentUploadForm';
import WorksService from '../WorksService';

function DocumentForm({ workId, document = null, onSave, onCancel }) {
  return (
    <DocumentUploadForm
      service={WorksService}
      ownerId={workId}
      document={document}
      onSave={onSave}
      onCancel={onCancel}
      createLabel="Subir"
      showHints
      strictResult
    />
  );
}

export default DocumentForm;
